module.exports = __webpack_public_path__ + "static/media/honeycomb-logo-full.ba7375cb.png";